import { createTypes } from '../../utils';

const types = createTypes('user', [
    'SET_USER_TOKEN'
]);

export default types;
